import React from 'react';
import { useSiteConfig } from '../hooks/useSiteConfig';
import Editable from '../components/Editable';
import './Pages.css';

const DEFAULT_ABOUT = {
  heading: 'About Us',
  mission: 'Our mission is to create meaningful, handcrafted pieces that bring beauty, function, and a personal touch into everyday life. We aim to turn simple materials into lasting items people can cherish and share.',
  paragraphs: [
    'At Kalsies Creations / California Handcraft, everything we make is created by hand with care, creativity, and attention to detail. We love turning simple materials into meaningful, one-of-a-kind pieces that people can use, gift, and enjoy every day.',
    'We specialize in handcrafted wood items, including cutting boards, signs, planters, trellises, and other unique pieces for the home. Many of our items can be customized with laser engraving, but we also offer beautiful, non-engraved pieces for a more natural look.',
    'In addition to our woodwork, we create handmade greeting cards and jewelry—perfect for adding a personal touch to any occasion. Whether custom or ready-made, our goal is to create pieces that feel special, thoughtful, and made just for you.',
  ],
  values: [
    { title: 'Quality', description: 'We strive for the highest quality in every project.' },
    { title: 'Passion & Authenticity', description: 'We pour our heart into every piece we create with honesty and accountability at the core of everything we do.' },
    { title: 'Timeliness', description: 'We work closely with our clients to achieve shared goals.' },
  ],
  team: [
    {
      name: 'James Curtis',
      role: 'Artisan and Wood Worker',
      bio: 'James brings his love of woodworking to life through planters, cutting boards, trellises, clocks, baskets, and more. A retired professional, he started crafting as a hobby and enjoys sharing his passion for quality handmade woodwork with others, along with his love of gardening and travel.',
      image_url: '/james-photo.jpg',
    },
    {
      name: 'Gina Curtis',
      role: 'Designer and Laser Engraving Specialist',
      bio: 'Gina creates personalized designs, laser-engraved wood items, handmade cards, magnets, wooden jewelry, and more. She also crafts cold-process soaps and scented wax melts, combining creativity with a passion for making unique, personal items—and she loves traveling to inspire her work.',
      image_url: '/Gina photo.jpg',
    },
  ],
};

export default function About() {
  const { config } = useSiteConfig();
  const about = config.about || DEFAULT_ABOUT;
  const heading = about.heading || DEFAULT_ABOUT.heading;
  const mission = about.mission || DEFAULT_ABOUT.mission;
  const paragraphs = Array.isArray(about.paragraphs) && about.paragraphs.length
    ? about.paragraphs
    : DEFAULT_ABOUT.paragraphs;
  const values = Array.isArray(about.values) && about.values.length
    ? about.values
    : DEFAULT_ABOUT.values;
  const team = Array.isArray(about.team) && about.team.length
    ? about.team
    : DEFAULT_ABOUT.team;

  return (
    <main className="page-content">
      <Editable descriptor={{ kind: 'config', key: 'about', label: 'About page — heading, mission, paragraphs, values & team' }}>
      <section className="page-hero">
        <div className="container">
          <h1>{heading}</h1>
          <p>{mission}</p>
        </div>
      </section>

      <section className="container page-section" style={{ marginTop: '3rem' }}>
        {paragraphs.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </section>

      <section className="values-section">
        <div className="container">
          <h2>Our Values</h2>
          <div className="values-grid">
            {values.map((v, i) => (
              <div className="value-card" key={i}>
                <h3>{v.title}</h3>
                <p>{v.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="container page-section">
        <h2>Meet Our Team</h2>
        <div className="team-grid">
          {team.map((m, i) => (
            <div className="team-member" key={i}>
              <div className="member-image">
                {m.image_url ? <img src={m.image_url} alt={m.name || 'Team member'} /> : null}
              </div>
              <h3>{m.name}</h3>
              {m.role && <p className="role">{m.role}</p>}
              {m.bio && <p>{m.bio}</p>}
            </div>
          ))}
        </div>
      </section>
      </Editable>
    </main>
  );
}
